var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},_vm._l((_vm.blocks),function(i){return _c('div',{key:i.key,staticClass:"item",class:{
        grayscaled:
          _vm.lotteryPending &&
          !i.isBtn &&
          i.index !== Math.floor(_vm.currentHighlightIndex % 8)
      },style:(i.isBtn ? _vm.fireBtnBgStyle : _vm.rewardBgStyle),on:{"click":function($event){i.tapHandler ? i.tapHandler() : function () {}}}},[_c('div',{staticClass:"awardIcon"},[_c('Award',{attrs:{"awardData":i}})],1),_c('div',[_vm._v(_vm._s(i.name))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }